<app-header flexLayout="column"></app-header>
<app-navbar flexLayout="column"></app-navbar>
<div class="content">
  <router-outlet></router-outlet>
</div>

<app-footer flexLayout="column"></app-footer>
